import * as React from 'react';

const SvgSmallArrow = (props) => (
  <svg
    width={12}
    height={12}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.226 4.21a.375.375 0 0 0-.53 0l-3.26 3.26a.618.618 0 0 1-.87 0l-3.26-3.26a.375.375 0 0 0-.53.53L5.036 8a1.368 1.368 0 0 0 1.93 0l3.26-3.26a.375.375 0 0 0 0-.53Z'
      fill='#333'
    />
  </svg>
);

export default SvgSmallArrow;
